import React from 'react';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import Heading from '../Heading';
import { DetailProps } from '../types';
import Mobile from './Mobile';
import Desktop from './Desktop';
import { PlatformType } from '@invideoio/web-shared/constants/common';

const Detail = (props: DetailProps) => {
  const { heading, highlightedText, desktop, mobile, platform } = props;
  return (
    <React.Fragment>
      <div className={ivclass('iv-pb-30 md:iv-pb-40 lg:iv-pb-64 xl:iv-pb-64')}>
        <Heading heading={heading} highlightedText={highlightedText} />
      </div>
      {(platform !== PlatformType.Desktop && (
        <Mobile
          CTAText={mobile.CTAText}
          subInfo={mobile.subInfo}
          inputPlaceholder={mobile.inputPlaceholder}
          CTAUrl={mobile.CTAUrl}
        />
      )) || (
        <Desktop
          CTAText={desktop.CTAText}
          CTAUrl={desktop.CTAUrl}
          subInfo={desktop.subInfo}
        />
      )}
    </React.Fragment>
  );
};

export default Detail;
